import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import caretRight from "../../../../img/misc/caret-right.svg";
import { useAppDispatch, useAppSelector } from "../../../apps/reducers";
import { assertNever } from "../../../utils/never";
import { MattressSelectorSize } from "../components/MattressSize";
import { MattressOption } from "../components/Option";
import { MattressMatchResults } from "../components/Results";
import { Step, stepOrder } from "../constants";
import { OptionStepsType } from "../models";
import { onNavigate } from "../reducers";
import { MattressMatchNav } from "./MattressMatchNav";

import styles from "./MattressMatch.module.scss";

export const MattressMatch = (): React.JSX.Element => {
    const mattressMatchUiState = useAppSelector(
        (state) => state.mattressmatch.ui,
    );
    const { currentScreen } = mattressMatchUiState;
    const dispatch = useAppDispatch();
    function buildScreen(step: Step): React.JSX.Element {
        switch (step) {
            case Step.SIZE:
                return <MattressSelectorSize />;
            case Step.RESULTS:
                return <MattressMatchResults />;
            default:
                return (
                    <MattressOption
                        step={step as keyof OptionStepsType}
                        key={step}
                    />
                );
        }
        assertNever(step as never);
    }

    return (
        <>
            <div className={styles.container} data-screen={currentScreen}>
                {buildScreen(stepOrder[currentScreen])}
                {currentScreen === stepOrder.indexOf(Step.SIZE) && (
                    <div className={styles.buttonContainer}>
                        <button
                            className={styles.button}
                            onClick={() => {
                                dispatch(
                                    onNavigate({
                                        currentScreen: currentScreen + 1,
                                    }),
                                );
                            }}
                        >
                            {t`Get Started`}
                            <SVG src={caretRight} />
                        </button>
                    </div>
                )}
                {currentScreen > stepOrder.indexOf(Step.SIZE) && (
                    <MattressMatchNav />
                )}
            </div>
        </>
    );
};
